// extracted by mini-css-extract-plugin
export var cookiesWrapper = "style-module--cookiesWrapper--DrTJX";
export var cookiesContainer = "style-module--cookiesContainer--92JNK";
export var text = "style-module--text--jO5i-";
export var button = "style-module--button--AsMyc";